"use client";

import styles from "./RangeLink.module.scss";

type Props = {
  /**
   * A string representing the URL to be set.
   */
  setUrl: string;
  /**
   * A string representing the title to be set.
   */
  setTitle: string;
};

export function RangeLinkUI({ setUrl, setTitle }: Props) {
  return (
    <div
      data-testid="range-link"
      className={styles.rangeLink}
      data-component="RangeLink"
    >
      <a href={setUrl}>View full range from {setTitle}</a>
    </div>
  );
}
